import { Image } from '@petsmart-ui/sparky';
import { useState } from 'react';

import { decodeEntityString } from '@libs/algolia';

import type { ProductSearchItem } from '../../../search.types';
import ProductImageFallback from './product-image-fallback.icon.svg';
import { ProductPrice } from './product-price';

type ProductResultProps = {
    product: ProductSearchItem;
};

export function ProductResult({ product }: Readonly<ProductResultProps>) {
    const imageUrl = product.image.small ?? product.image.large;
    const [failedImageUrl, setFailedImageUrl] = useState<string>();
    const showImageFallback = !imageUrl || failedImageUrl === imageUrl;

    return (
        <div className="header-search__product">
            {showImageFallback && (
                <ProductImageFallback
                    aria-label={`${product.label} image unavailable`}
                    className="header-search__product-image"
                    role="img"
                />
            )}
            {!showImageFallback && (
                <Image
                    className="header-search__product-image"
                    src={imageUrl}
                    alt={`${product.label} image`}
                    loading="lazy"
                    onError={() => setFailedImageUrl(imageUrl)}
                    width={64}
                    height={64}
                />
            )}
            <div className="header-search__product-main">
                <div className="header-search__product-name">{decodeEntityString(product.label)}</div>
                {product.price && <ProductPrice price={product.price} />}
            </div>
        </div>
    );
}
